import { useCallback, useEffect, useRef, useState } from "react";
/** 倒计时组件 */

var useCountDown = function (_a) {
  var _b = _a.start,
      start = _b === void 0 ? 0 : _b,
      onChange = _a.onChange,
      onTimeout = _a.onTimeout;

  var _c = useState(start),
      leftTime = _c[0],
      setLeftTime = _c[1];

  var now = Date.now();
  var timerId = useRef(null);
  var timeRef = useRef(start);
  var countHandle = useCallback(function () {
    if (timeRef.current <= 0) {
      clearInterval(timerId.current);
      onTimeout && onTimeout();
      setLeftTime(0);
      return timeRef.current = 0;
    }

    var count = Number(((Date.now() - now) / 1000).toFixed(0));
    var current = start - count < 0 ? 0 : start - count;
    timeRef.current = current;
    setLeftTime(current);
    onChange && onChange(current);
  }, [start]);
  useEffect(function () {
    if (start && start > 0) {
      timeRef.current = start;
      setLeftTime(start);
      timerId.current = setInterval(countHandle, 1000);
    }

    return function () {
      if (timerId.current) {
        clearInterval(timeRef.current);
      }
    };
  }, [start]);
  return [leftTime];
};

export { useCountDown };